import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryV1 } from './baseQueryV1';

export const lunchBreakTrackApi = createApi({
  reducerPath: 'lunchBreakTrackApi',
  baseQuery: baseQueryV1,
  tagTypes: ['LunchBreakTrack'],
  endpoints: (builder) => ({
    getLunchBreakTracks: builder.query({
      query: (params) => ({
        url: 'lunch-break-tracks',
        method: 'GET',
        params,
      }),
      transformResponse: (res) => res?.data,
      providesTags: ['LunchBreakTrack'],
    }),
    approveLunchBreakTrack: builder.mutation({
      query: (id) => ({
        url: `lunch-break-tracks/${id}/approve`,
        method: 'PATCH',
      }),
      invalidatesTags: ['LunchBreakTrack'],
    }),
    rejectLunchBreakTrack: builder.mutation({
      query: ({ id, rejection_reason }) => ({
        url: `lunch-break-tracks/${id}/reject`,
        method: 'PATCH',
        body: { rejection_reason },
      }),
      invalidatesTags: ['LunchBreakTrack'],
    }),
    bulkApproveLunchBreakTracks: builder.mutation({
      query: (ids) => ({
        url: 'lunch-break-tracks/bulk/approve',
        method: 'PATCH',
        body: { ids },
      }),
      invalidatesTags: ['LunchBreakTrack'],
    }),
    bulkRejectLunchBreakTracks: builder.mutation({
      query: ({ ids, rejection_reason }) => ({
        url: 'lunch-break-tracks/bulk/reject',
        method: 'PATCH',
        body: { ids, rejection_reason },
      }),
      invalidatesTags: ['LunchBreakTrack'],
    }),
  }),
});

export const {
  useGetLunchBreakTracksQuery,
  useApproveLunchBreakTrackMutation,
  useRejectLunchBreakTrackMutation,
  useBulkApproveLunchBreakTracksMutation,
  useBulkRejectLunchBreakTracksMutation,
} = lunchBreakTrackApi;
